import { Component, computed, effect, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface Notification {
  type: 'red-flag' | 'green-flag' | 'yellow-flag' | 'info';
  label?: string;
  message: string;
  detail?: string;
}

@Component({
  selector: 'vb-lxp-notification',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './vb-lxp-notification.component.html',
  styleUrl: './vb-lxp-notification.component.css',
  host: { class: 'vb-lxp-notification-host' },
})
export class VbLxpNotificationComponent {
  public notification = input<Notification | null>(null);
  private dismissed = signal(false);
  private exiting = signal(false);

  public isVisible = computed(() => !this.dismissed() && this.notification() !== null);
  public bannerClasses = computed(() => ({
    [this.notification()?.type ?? '']: true,
    visible: this.isVisible() && !this.exiting(),
    exiting: this.exiting(),
  }));

  constructor() {
    effect(() => {
      this.notification();
      this.dismissed.set(false);
      this.exiting.set(false);
    });
  }

  public dismiss() {
    this.exiting.set(true);
    setTimeout(() => {
      this.dismissed.set(true);
      this.exiting.set(false);
    }, 350);
  }

  public getIconSVG(): string {
    const type = this.notification()?.type || 'info';
    switch (type) {
      case 'red-flag':
        return `<svg fill="currentColor" viewBox="0 0 24 24"><path d="M6 3v12l5-3 5 3V3z"/></svg>`;
      case 'green-flag':
        return `<svg fill="currentColor" viewBox="0 0 24 24"><path d="M6 3v12l5-3 5 3V3z"/></svg>`;
      case 'yellow-flag':
        return `<svg fill="currentColor" viewBox="0 0 24 24"><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/></svg>`;
      default:
        return `<svg fill="currentColor" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v2h-2zm0 4h2v6h-2z"/></svg>`;
    }
  }
}
